export default __webpack_public_path__ + "static/media/glasses.cb422c60.svg";